import React from 'react'
import Field from './Field'
import { dateFormat } from '../../../hepler/functions'
import { useTranslation } from '../../../hooks/useTranslation';

function ConsentRequestedExpires(props) {
  const { t } = useTranslation();
  return (
    <>
      <Field
          property={t('paymentConsent.purposeTexts.l1Parameters.consentRequestedOn')}
          value={dateFormat(props?.consentDetails?.startTime, true)}
          customDetails={props?.customDetails}
      />
      <Field
        property={t('paymentConsent.purposeTexts.l1Parameters.consentExpiresOn')}
        value={dateFormat(props?.consentDetails?.expireTime, true)}
        customDetails={props?.customDetails}
        valueStyles={{ color: 'red' }} />
    </>
  )
}

export default ConsentRequestedExpires